export default __webpack_public_path__ + "static/media/undraw_mobile_testing_reah.6f04effe.svg";